/* @flow */
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import {
  REPROCESS_REPORTS,
  REPROCESS_REPORTS_SUCCESS,
  REPROCESS_REPORTS_FAILURE,
} from './action-types.js';

export const REPROCESS_REPORTS_ENDPOINT = '/services/incident-reports/reprocess-all';
/**
 * Reprocess incident reports.
 */
const reprocessReportsEpic = (action$, store, { ajax }) =>
  action$.ofType(REPROCESS_REPORTS)
    .mergeMap(x => {
      if (x.payload && x.payload.dateSince && x.payload.dateUntil) {
        return ajax.post(REPROCESS_REPORTS_ENDPOINT, x.payload)
        .mapTo({ type: REPROCESS_REPORTS_SUCCESS })
        .catch(err => Observable.of({
          type: REPROCESS_REPORTS_FAILURE,
          error: true,
          payload: err,
          meta: {
            alert: { type: 'error', text: 'An error occurred re-processing incident reports.' },
          },
        }));
      } else {
        return Observable.of({
          type: REPROCESS_REPORTS_FAILURE,
          error: true,
          payload: new Error('Both date fields must be selected.'),
          meta: {
            alert: { type: 'error', text: 'Both date fields must be selected.' },
          },
        });
      }
    });

export default combineEpics(
  reprocessReportsEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/devtasks/epics.js